import { type StatsigUser } from "@statsig/react-bindings";
import { parse } from "cookie";

export const STATSIG_CLIENT_INIT_VALUE_COOKIE_NAME = "_sciv";
export const STATSIG_STABLE_ID_COOKIE_NAME = "_ssi";
export const STATSIG_USER_COOKIE_NAME = "_ssui";

export function getClientBootstrapValues() {
  const cookies = parse(document.cookie);
  const clientBootstrapValues = cookies[STATSIG_CLIENT_INIT_VALUE_COOKIE_NAME];
  const encodedUser = cookies[STATSIG_USER_COOKIE_NAME];
  const stableId = cookies[STATSIG_STABLE_ID_COOKIE_NAME];

  let userInfo: StatsigUser = {};
  if (encodedUser) {
    const decodedUser = JSON.parse(atob(decodeURIComponent(encodedUser)));
    userInfo = decodedUser;
  } else if (stableId) {
    userInfo = {
      customIDs: {
        stableID: stableId,
      },
    };
  }

  return { clientBootstrapValues, userInfo };
}
